import React from "react"

import { Grid, IconButton, Popover, Typography } from "@material-ui/core"
import useStyles from "@/pages/Admin/TrackableLinks/MessageTipsPopover/styles"

const TIPS = ["Peça explicitamente para não apagar", "Mostre que a mensagem é necessária para o atendimento", "Destaque a importância da mensagem", "Use emojis para chamar a atenção", "Seja claro e objetivo na mensagem", "Evite mensagens longas e cansativas", "Use uma linguagem amigável e acessível"]

const MessageTipsPopover: React.FC = () => {
	const [popoverAnchorElement, setPopoverAnchorElement] = React.useState<HTMLElement | null>(null)
	const [isPopoverOpen, setIsPopoverOpen] = React.useState(false)

	const classes = useStyles()

	const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
		setPopoverAnchorElement(event.currentTarget)
		setIsPopoverOpen(true)
	}

	const handlePopoverClose = () => {
		setPopoverAnchorElement(null)
		setIsPopoverOpen(false)
	}

	return (
		<>
			<IconButton
				className={classes.iconButton}
				aria-owns={isPopoverOpen ? "mouse-over-popover" : undefined}
				aria-haspopup="true"
				onClick={handlePopoverOpen}
			>
				<Typography variant="h5">
					Veja algumas dicas! 💡
				</Typography>
			</IconButton>
			<Popover
				id="mouse-over-popover"
				open={isPopoverOpen}
				onClose={handlePopoverClose}
				anchorEl={popoverAnchorElement}
				classes={{
					paper: classes.popover
				}}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center"
				}}
				transformOrigin={{
					vertical: "bottom",
					horizontal: "center"
				}}>
				<Grid container direction="column" spacing={3}>
					<Grid item>
						<Grid container direction="column" spacing={1}>
							<Grid item>
								<Typography variant="h5" className={classes.popoverTitle}>
									Dicas para uma mensagem que o cliente não vai deletar! 💡
								</Typography>
							</Grid>
							<Grid item>
								<Typography variant="body2">
									A mensagem que você adicionar aqui conterá um código invisível, que é a única forma de identificarmos de qual link o cliente veio. Caso essa mensagem seja alterada pelo cliente, não será possível rastrear o contato corretamente. Por isso, é importante que você crie uma mensagem que o cliente não tenha vontade de apagar.
								</Typography>
							</Grid>
						</Grid>
					</Grid>
					<Grid item>
						<Typography variant="h5">
							Algumas dicas:
						</Typography>
						<ul style={{ marginTop: 8 }}>
							{TIPS.map((tip, index) => (
								<li key={index} className={classes.tip}>
									<Typography variant="body2">
										- {tip}
									</Typography>
								</li>
							))}
						</ul>
					</Grid>
					<Grid item>
						<Typography variant="h5">
							Exemplo:
						</Typography>
						<Typography variant="body2" className={classes.exampleMessage}>
							Olá! Para iniciarmos seu atendimento, é muito importante que você não apague esta mensagem. Ela garante que seu pedido seja processado corretamente. Vamos começar? 🚀
						</Typography>
					</Grid>
					<Grid item>
						<Typography variant="body2">
							Essas dicas são apenas sugestões, use sua criatividade! 😉
						</Typography>
					</Grid>
				</Grid>
			</Popover>
		</>
	)
}

export default MessageTipsPopover
